import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import CrmOffersWrapper from "@components/layouts/crmOffersWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function InsureYourCarHome(): ReactElement {
    return (
        <CrmOffersWrapper>
            <TermsAndConditions category="CRM" domain="CrmOffers.com" />
        </CrmOffersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
